var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdmin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg8",
    viewBox: "0 0 9.8438931 9.8438978",
    height: "9.8438978mm",
    width: "9.8438931mm",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-34.562538,-249.24352)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path838",
    d: "m 34.644679,249.32566 h 9.563446 l -9.563446,9.56345 z",
    style: {
      fill: "#ff5555",
      stroke: "#2800cc",
      strokeWidth: 0.16428228,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "rotate(-45)",
    id: "text842",
    y: 206.34142,
    x: -155.29021,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "2.0445025px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.05111256
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fill: "#000080",
      strokeWidth: 0.05111256
    },
    y: 206.34142,
    x: -155.29021,
    id: "tspan840"
  }, "ADMIN"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.5f518676f41a9597b98f1dac2378fd4d.svg";
export { ForwardRef as ReactComponent };